module.exports = __webpack_public_path__ + "img/logoFootie.6e05c078.png";